import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface SnackbarState {
    open: boolean;
    reason: string;
    message: string;
}

const initialState: SnackbarState = {
    open: false,
    reason: "",
    message: "",
};

const snackbarSlice = createSlice({
    name: "snackbar",
    initialState,
    reducers: {
        showSnackbar(state, action: PayloadAction<{ reason: string; message: string}>) {
            const { reason, message } = action.payload;
            state.open = true;
            state.reason = reason;
            state.message = message;
        },
        hideSnackbar(state) {
            state.open = false;
            state.reason = "";
            state.message = "";
        },
    },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;

export type { SnackbarState };